import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk'; // Middleware
import { routerReducer, routerMiddleware } from 'react-router-redux'
import { createTracker } from 'redux-segment'; //Middleware for segment.io
import LogRocket from 'logrocket';

import history from './history';
import { reducer as dataReducer } from 'data/reducer';
import { reducer as sceneReducer } from 'scenes/reducer';
import { reducer as authReducer } from 'services/auth/reducer'

const tracker = createTracker();
const appReducer = combineReducers({
  data: dataReducer,
  scene: sceneReducer,
  auth: authReducer,
  router: routerReducer
});

const router = routerMiddleware(history)

const store = createStore(
  appReducer,
  {} /* initial state */,
  applyMiddleware(thunk, tracker, router, LogRocket.reduxMiddleware()) /* store enhancer */
);

export default store;



// WEBPACK FOOTER //
// ./src/lib/store.js